import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Col, Row, Image, Spin, Space, Typography, Popconfirm } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import deleteDataById from "../../../hooks/admin/deleteDataById";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const { Title } = Typography;

const AdminPaymentMethods = () => {
  const { t } = useTranslation();
  const [gateway, setGateway] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("admin"));

  useEffect(() => {
    const getAllGateways = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_APIURL}/admin/getallpaymentgateway`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        const response = await res.json();

        if (response.data) {
          setGateway(response.data);
        }
      } catch (error) {
        toast.error(t("Fetch_Error"));
      }
    };

    getAllGateways();
  }, [t, user.token]);

  const deleteGateway = async (id) => {
    setLoading(true);
    const res = await deleteDataById("admin/deletepaymentgateway", id);

    if (res.status_code === 200) {
      setGateway((prev) => prev.filter((item) => item.id !== id));
      toast.success(t("Deleted_Successfully"));
    } else {
      toast.error(res?.message || res?.err || t("Delete_Failed"));
    }
    setLoading(false);
  };

  return (
    <Spin spinning={loading}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Title level={4}>{t("All_Payment_Gateway")}</Title>
        </Col>
        <Col>
          <Link to="/admin/payment-gateway/add">
            <button className="btn btn-sm btn-primary text-white">
              <span className="mr-2" ><PlusOutlined /></span>  {t("Add_Gateway")}
            </button>
          </Link>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        {gateway.map((item) => (
          <Col xs={24} md={12} lg={8} key={item.id}>
            <Card
              bordered

              cover={
                <div style={{ padding: "16px", textAlign: "center" }}>
                  <Image
                    src={item.gateway_image}
                    alt={item.gateway_name}
                    width={100}
                    height={80}
                    style={{ objectFit: "contain" }}
                    preview={false}
                  />
                </div>
              }
              actions={[
                <Link key="edit" to={`/admin/payment-gateway/edit/${item.id}`}>
                  <Button type="link" icon={<EditOutlined />} block>
                    {t("Edit")}
                  </Button>
                </Link>,
                <Popconfirm
                  key="delete"
                  title={t("delete_alert_title")}
                  description={t("delete_alert_des")}
                  onConfirm={() => deleteGateway(item.id)}
                  okText={t("yes")}
                  cancelText={t("no")}
                  okButtonProps={
                    { style: { backgroundColor: "#f4900c", borderColor: "#f4900c", color: "white" } }
                  }
                >
                  <Button danger type="link" icon={<DeleteOutlined />} block>
                    {t("Delete")}
                  </Button>
                </Popconfirm>,
              ]}
            >
              <Card.Meta title={item.gateway_name} />
            </Card>
          </Col>
        ))}
      </Row>
    </Spin>
  );
};

export default AdminPaymentMethods;
